import { useEffect, useState } from "react";
import { Table1 } from "../../components/table/Table1";
import {
  ChangeTitle,
  toAbsoluteUrl,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { MdContentCopy } from "react-icons/md";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ImportantLinks = () => {
  ChangeTitle("Important Links");

  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(5);
  const [sortField, setSortField] = useState("created");
  const [sortOrder, setSortOrder] = useState("desc");
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState([]); // All Data List

  // Important Links List Api call
  const viewImportantLinksList = async (
    search,
    sortOrder,
    sortField,
    limit,
    offset
  ) => {
    const param = {
      term: search,
      sort: sortOrder,
      sortBy: sortField,
      limit: limit,
      offset: offset,
    };
    var response = await postData(
      "importantlink/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const totalRecords = response.data.data.totalRecord;
      setData(data);
      setTotalRecords(totalRecords);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewImportantLinksList(search, sortOrder, sortField, limit, offset);
  }, [search, sortOrder, sortField, limit, offset]);

  // table columns
  const columns = [
    {
      class: "min-w-[100px]",
      name: <label className="st-head-tr-th-text">Sr. no.</label>,
      cell: (row, rowIndex, baseIndex) => {
        const srNo = baseIndex + rowIndex + 1;
        return srNo;
      },
      sortable: false,
      field: "_id",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Country</label>,
      cell: (row) => row.country.countryName,
      sortable: true,
      field: "country.countryName",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Areas</label>,
      cell: (row) => row.taxservice.serviceName,
      sortable: true,
      field: "taxservice.serviceName",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Remark</label>,
      cell: (row) => row.remark,
      sortable: true,
      field: "remark",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">English version</label>,
      cell: (row) => (
        <div className="flex items-center">
          <a href={row.englishVersion} target="_blank">
            {row.englishVersion}
          </a>
          {row.englishVersion && (
            <button
              className="btn btn-sm btn-light-info ms-3 py-1 px-2 table-doc-icon"
              title="Copy"
              onClick={() => {
                navigator.clipboard.writeText(row.englishVersion);
                toastsuccessmsg("Link Copied.");
              }}
            >
              <MdContentCopy className="fs-3" />
            </button>
          )}
        </div>
      ),
      sortable: true,
      field: "englishVersion",
    },
  ];
  
  const handleSort = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
    setOffset(0); // Reset to the first page on sort change
    viewImportantLinksList(search, newSortOrder, field, limit, offset);
  };

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="w-full mb-[5%] md:mb-[2%]">
          <h1 className="hanson text-center mb-[1%] heading">
            Important links
          </h1>
          <img
            className="mb-[2%] mx-auto"
            src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
            alt=""
          />
        </div>
        <Table1
          className="p-[3%] md:p-[1%] mb-5 lg:mb-8"
          columns={columns}
          data={data}
          totalRecords={totalRecords}
          additionalField={""}
          searchPlaceholder="Search important links"
          searchValue={search}
          setSearchValue={(e) => {
            setSearch(e.target.value);
            setOffset(0);
          }}
          limit={limit}
          offset={offset}
          setOffset={setOffset}
          isAllowAllList={true}
          setLimit={setLimit}
          sortField={sortField}
          sortOrder={sortOrder}
          handleSort={handleSort}
        />
      </div>
    </>
  );
};

export default ImportantLinks;
